import React from 'react';

// a lazy option of italic split
export const renderWithLineBreaksAndItalic = (text) => {
    const lines = text.split('\n');
    return lines.map((line, lineIndex) => {
        // splits  Hey there! **Glad** you could make it. -> ["Hey there!", "**Glad**", "you could make it"]
        const b_splits = line.split(/(\*[^*]+\*)/g);
        const newLine = b_splits.map((i_split, i) => {
            // here we get rid of ** ** and simply place <b> </b> instead
            if (/^\*[^*]+\*$/.test(i_split)) {
                return <i style={{color : "#fffcfc"}} key={i}>{i_split.slice(1, -1)}</i>;
            }
            return <React.Fragment key={i}>{i_split}</React.Fragment>;
        });
        return (
            <React.Fragment key={lineIndex}>
            {newLine}
            <br />
            </React.Fragment>
        );
    });
};